export default __webpack_public_path__ + "static/media/photo--lg--mike2.56e02ae6.jpg";